import { TUser } from "../../../../@types/data/user"
import { getOrderData } from "../../../order"
import { getAdditionalTax } from "../../../taxes"

export const getOrderValue = (
  currentTickets: any[],
  currentBuyer: any,
  taxTotal: any,
  sid: string,
  user: TUser,
  dk: string,
  eventId: string,
  eventName: string,
  chargeClient: boolean,
  additionalTax?: {
    method: "pix" | "credit"
    additionalTaxPix?: number | null
    additionalTaxCard?: number | null
  }
) => {
  const parsedTaxTotal = !Number.isNaN(+taxTotal) ? Number(taxTotal) : 0

  const obj = getOrderData({
    tickets: currentTickets,
    buyer: currentBuyer,
    taxTotal: parsedTaxTotal,
    sid,
    user: user,
    dk: dk,
    eventId: eventId,
    eventName: eventName,
    chargeClient,
    additionalTaxPix:
      additionalTax?.method === "pix" ? additionalTax.additionalTaxPix : null,
  })

  if (!obj) return 0

  let amount = obj.transaction_amount

  if (additionalTax?.method === "credit") {
    amount += getAdditionalTax({
      baseTotal: amount - (chargeClient ? parsedTaxTotal : 0),
      method: "credit",
      additionalTaxCard: additionalTax.additionalTaxCard,
    })
  }

  return amount
}
